export const errorMessageDisplay = (requestError) => {
    let message = requestError["graphQLErrors"][0]["message"];
    return message[0].toUpperCase() + message.slice(1)
};
